import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Confirm from 'app/components/Confirm';
import { selectCampaign, CampaignTypeList, CampaignTypes, FEATURE_RELEASE_DATE, DIALER_NEW_BADGE_EXPIRATION_DAYS } from 'data/campaigns';
import { campaignPath } from 'app/routes';
import { selectProfile, getMarketingUrl, selectListManagementEnabled, selectUserId } from 'data/user';
import { openLeadAutomatorUpgrade } from 'data/user/actions';
import { getBrandRedirectMessage } from 'utils/brand';
import SVG from 'components/base/SVG';

import css from './style.scss';
import cssModal from "../../../app/AccountNew/style.scss"
import LeadAutomatorUpgrade from '../../../components/DialerCampaign/LeadAutomatorUpgrade/LeadAutomatorUpgrade';
import NoEligibleLeads from '../../../app/AccountNew/modals/NoEligibleLeads';
import { checkContactsPropertyAssociation, createDialerCampaign, getMarketingProfile } from '../../../data/user/actions';
import { createDirectMailCampaign } from 'data/campaigns/actions';
import { handleDialerEligibility } from './DialerEligibility';
import CreateDirectMailHandler from './DirectMail/CreateDirectMailHandler';
import CampaignActivitySettingsModal from '../CampaignActivitySettingsModal';
import FullAccessRequiredModal from "components/ClickToDial/FullAccessRequiredModal/FullAccessRequiredModal";
import { isPropStream } from 'utils/brand';

import { isLegacyAccountPlan } from "data/user/selectors";
import LeaveMessagePopup from "../../../app/AccountNew/modals/LeaveMessage";

// Dialer "New!" badge Visible for 90 days from PROD release date

const isDialerFeatureNew = () => {
  const expirationDate = new Date(FEATURE_RELEASE_DATE);
  expirationDate.setDate(
    expirationDate.getDate() + DIALER_NEW_BADGE_EXPIRATION_DAYS
  );

  return new Date() < expirationDate;
};

class Activities extends PureComponent {

  state = {
    showNoEligibleLeads: false,
    isCheckingEligibility: false,
    showModal: false,
    pendingActivityType: null,
    pendingContactIds: null,
  };

  getIconForType = (type) => {
    if (type.code === CampaignTypes.DIALER.code) {
      return 'iconDialer';
    } else if (type.code === CampaignTypes.POSTCARD.code) {
      return 'iconPostcardNew';
    } else if (type.code === CampaignTypes.DIRECTMAIL.code) {
      return 'iconPostcardNew';
    } else if (type.code === CampaignTypes.EMAIL.code) {
      return 'iconEmail';
    }
    return null;
  };

  handleDialerClick = (e, cardUrl) => {
    if (this.props.profile?.get?.("type") === 'TEAM') {
      this.props.openFullAccessRequiredModal({ onClose: this.props.closeFullAccessRequiredModal });
      return;
    }

    if (this.state.isCheckingEligibility) return;

    handleDialerEligibility({
      campaign: this.props.campaign,
      hasLeadAutomator: this.props.hasLeadAutomator,
      isLegacyAccount: this.props.isLegacyAccount,
      leaveMessagePopup: this.props.leaveMessagePopup,
      openLeadAutomatorUpgrade: this.props.openLeadAutomatorUpgrade,
      checkContactsPropertyAssociation: this.props.checkContactsPropertyAssociation,
      createDialerCampaign: this.props.createDialerCampaign,
      history: this.props.history,
      setState: this.setState.bind(this),
      onEligible: (contactIds) => {
        this.setState({
          showModal: true,
          pendingActivityType: 'DIALER',
          pendingContactIds: contactIds,
        });
      },
    });
  };

  handleDirectMailClick = async (e, cardUrl) => {
    const handler = new CreateDirectMailHandler(this.props.userId, this.props.campaign.toJS(), null,
      this.props.createDirectMailCampaign, this.props.getMarketingProfile);
    const campaign = await handler.run();

    this.props.history.push({ pathname: cardUrl, state: { isNewCampaign: true, newCampaign: campaign } });
  };

  handleClick = (type, url, e) => {
    const { onClick, confirm } = this.props;

    if (url) {
      e.preventDefault();
      this.setState({
        showModal: true,
        pendingActivityType: type.code.toUpperCase(),
        pendingUrl: url,
        pendingType: type,
      });
      if (onClick) onClick();
      confirm({
        question: getBrandRedirectMessage(url),
        okLabel: 'Continue',
        onOk: () => {
          this.setState({
            showModal: true,
            pendingActivityType: type.code.toUpperCase(),
            pendingUrl: url,
            pendingType: type,
          });
          document.contactAppendForm.target = type.name;
          document.contactAppendForm.action = url;
          document.contactAppendForm.submit();
        },
      });
    }
  };

  handleModalSave = (name) => {
    const marketingCampaignId = this.props.campaign.get('id');
    const { pendingActivityType, pendingContactIds, pendingUrl, pendingType } = this.state;

    if (pendingActivityType === 'DIALER') {
      const contactIds = pendingContactIds;

      this.props.createDialerCampaign({
        name,
        marketingCampaignId,
        contactIds,
        originatingListName: this.props.campaign.get('name'),
      })
        .then((res) => {
          this.setState({
            showModal: false,
            pendingActivityType: null,
            pendingContactIds: null,
          });

          this.props.history.push(`/campaign/${marketingCampaignId}/dialer/${res.id}`);
        })
        .catch((err) => {
          this.setState({
            showModal: false,
            pendingActivityType: null,
            pendingContactIds: null,
          });
          this.props.history.push(campaignPath(marketingCampaignId));
        });
    }

    if (pendingActivityType === 'POSTCARD') {
      const { campaign } = this.props;
      const marketingCampaignId = campaign.get('id');

      const cardUrl = campaignPath(`${marketingCampaignId}/postcard`);

      this.setState({ showModal: false, pendingActivityType: null, pendingUrl: null, pendingType: null },
        () => {
          this.props.history.push(cardUrl, { name });
        }
      );
    }

    if (pendingActivityType === 'EMAIL') {
      const { campaign } = this.props;
      const cardUrl = campaignPath(`${campaign.get('id')}/email`);
      this.setState({ showModal: false, pendingActivityType: null }, () => {
        this.props.history.push(cardUrl, { activityName: name });
      });
    }
  }

  render() {
    const { campaign, profile } = this.props;
    return (
      <div className={css.activitiesCard}>
        <div className={css.activitiesCardTitle}>Add a Campaign Activity to Get Started</div>
        <div className={css.activitiesInner}>
          {CampaignTypeList.filter(type => type.enabled).map((type) => {
            const url = getMarketingUrl(profile, type);
            const isDialer = type.code === CampaignTypes.DIALER.code;
            const isDirectMail = type.code === CampaignTypes.DIRECTMAIL.code;
            const cardUrl = !url ? campaignPath(`${campaign.get('id')}/${type.route}`) : null;

            // Not showing Dialer Campaign for Whitelabel accounts
            if (isDialer && !isPropStream()) {
              return;
            }

            return (
              <div className={css.activityCard} key={type.code}>
                {isDialer && isDialerFeatureNew() && (
                  <div className={css.newBadge}>New!</div>
                )}

                {cardUrl ? (
                  isDialer ? (
                    <div className={css.activityLink}
                      onClick={(e) => this.handleDialerClick(e, cardUrl)}
                      style={{ cursor: 'pointer' }}>
                      <div className={css.iconWrapper}>
                        <SVG icon="iconCircleBackground" className={css.circleBackground} />
                        <div className={css.iconInner}>
                          <SVG icon={this.getIconForType(type)} className={css.activityIcon} />
                        </div>
                      </div>
                      <div className={css.activityTitle}>{type.title}</div>
                    </div>
                  ) : (
                    <div className={css.activityLink}
                      onClick={(e) =>
                        !isDirectMail
                          ? this.setState({
                            showModal: true,
                            pendingActivityType: type.code.toUpperCase(),
                          })
                          : this.handleDirectMailClick(e, cardUrl)
                      }
                      style={{ cursor: 'pointer' }}>
                      <div className={css.iconWrapper}>
                        <SVG icon="iconCircleBackground" className={css.circleBackground} />
                        <div className={css.iconInner}>
                          <SVG icon={this.getIconForType(type)} className={css.activityIcon} />
                        </div>
                      </div>
                      <div className={css.activityTitle}> {type.title} </div>
                    </div>
                  )
                ) : (
                  <div
                    className={css.activityLink}
                    onClick={(e) => this.handleClick(type, url, e)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className={css.iconWrapper}>
                      <SVG icon="iconCircleBackground" className={css.circleBackground} />
                      <div className={css.iconInner}>
                        <SVG icon={this.getIconForType(type)} className={css.activityIcon} />
                      </div>
                    </div>
                    <div className={css.activityTitle}>{type.title}</div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <LeadAutomatorUpgrade />
        <div className={cssModal.clsIntegrationCard}>
          <NoEligibleLeads
            isOpen={this.state.showNoEligibleLeads}
            onClose={() => this.setState({ showNoEligibleLeads: false })}
            onConfirm={() => this.setState({ showNoEligibleLeads: false })}
          />
        </div>
        <CampaignActivitySettingsModal
          isOpen={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
          activityType={this.state.pendingActivityType}
          context="CAMPAIGN_TAB"
          campaignId={this.props.campaign.get('id')}
          onSave={this.handleModalSave}
          customClassName={css.activityCustomModal}
        />
      </div>

    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      campaign: selectCampaign(state),
      profile: selectProfile(state),
      userId: selectUserId(state),
      hasLeadAutomator: selectListManagementEnabled(state),
      isLegacyAccount: isLegacyAccountPlan(state),
    }), {
    confirm: Confirm.open,
    openLeadAutomatorUpgrade,
    checkContactsPropertyAssociation,
    createDialerCampaign,
    createDirectMailCampaign,
    getMarketingProfile,
    leaveMessagePopup: LeaveMessagePopup.open,
    openFullAccessRequiredModal: FullAccessRequiredModal.open,
    closeFullAccessRequiredModal: FullAccessRequiredModal.close,
    leaveMessagePopup: LeaveMessagePopup.open,
  })(Activities));
